import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const [visible, setVisible] = useState(false);
  const { pathname, hash } = useLocation();

  // 👇 1) Controla visibilidade do botão
  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);

    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  // 👇 2) Reseta scroll quando rota muda
  useEffect(() => {
    if (hash) {
      // Se tiver âncora (#sobre etc)
      setTimeout(() => {
        const element = document.querySelector(hash);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }, 50);
      return;
    }

    // Se for página normal (ex: /noticias/slug)
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname, hash]);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!visible) return null;

  return (
    <button
      onClick={scrollToTop}
      className="fixed bottom-6 right-6 bg-navy text-white p-3 rounded-full shadow-lg hover:scale-110 transition-transform duration-300 z-50"
      aria-label="Voltar ao topo"
    >
      ↑
    </button>
  );
}